"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.intersectPolygonRectangle = exports.intersectPolygonLineSegment = exports.intersectPolylineBounds = exports.intersectPolylineRectangle = exports.intersectPolylineLineSegment = exports.intersectBoundsPolygon = exports.intersectBoundsPolyline = exports.intersectBoundsEllipse = exports.intersectBoundsCircle = exports.intersectBoundsArc = exports.intersectBoundsBounds = exports.intersectBoundsRectangle = exports.intersectBoundsLineSegment = exports.intersectBoundsRay = exports.intersectEllipseBounds = exports.intersectEllipseCircle = exports.intersectEllipseEllipse = exports.intersectEllipseRectangle = exports.intersectEllipseLineSegment = exports.intersectEllipseRay = exports.intersectCircleBounds = exports.intersectCircleRectangle = exports.intersectCircleCircle = exports.intersectCircleLineSegment = exports.intersectArcBounds = exports.intersectArcRectangle = exports.intersectArcLineSegment = exports.intersectRectanglePolygon = exports.intersectRectanglePolyline = exports.intersectRectangleBounds = exports.intersectRectangleEllipse = exports.intersectRectangleCircle = exports.intersectRectangleArc = exports.intersectRectangleRectangle = exports.intersectRectangleLineSegment = exports.intersectRectangleRay = exports.intersectLineSegmentPolygon = exports.intersectLineSegmentPolyline = exports.intersectLineSegmentBounds = exports.intersectLineSegmentEllipse = exports.intersectLineSegmentCircle = exports.intersectLineSegmentArc = exports.intersectLineSegmentRectangle = exports.intersectLineSegmentLineSegment = exports.intersectLineSegmentRay = exports.intersectRayBounds = exports.intersectRayEllipse = exports.intersectRayRectangle = exports.intersectRayLineSegment = exports.intersectRayRay = void 0;
exports.intersectPolygonBounds = void 0;
var vec_1 = require("@tldraw/vec");
/**
 * Get an intersection.
 * @param message
 * @param points
 * @internal
 */
function createIntersection(message) {
    var points = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        points[_i - 1] = arguments[_i];
    }
    var didIntersect = points.length > 0;
    return { didIntersect: didIntersect, message: message, points: points };
}
/**
 *
 * @param point
 * @param size
 * @param rotation
 * @internal
 */
function getRectangleSides(point, size, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var center = [point[0] + size[0] / 2, point[1] + size[1] / 2];
    var tl = vec_1.Vec.rotWith(point, center, rotation);
    var tr = vec_1.Vec.rotWith(vec_1.Vec.add(point, [size[0], 0]), center, rotation);
    var br = vec_1.Vec.rotWith(vec_1.Vec.add(point, size), center, rotation);
    var bl = vec_1.Vec.rotWith(vec_1.Vec.add(point, [0, size[1]]), center, rotation);
    return [
        ["top", [tl, tr]],
        ["right", [tr, br]],
        ["bottom", [br, bl]],
        ["left", [bl, tl]],
    ];
}
/**
 * Get whether angle c lies between angles a and b.
 * @param a
 * @param b
 * @param c
 * @internal
 */
function isAngleBetween(a, b, c) {
    if (c === a || c === b)
        return true;
    var PI2 = Math.PI * 2;
    var AB = (b - a + PI2) % PI2;
    var AC = (c - a + PI2) % PI2;
    return AB <= Math.PI !== AC > AB;
}
/* -------------------------------------------------- */
/*                         Ray                        */
/* -------------------------------------------------- */
/**
 * Find the intersection between a ray and a ray.
 * @param p0 The first ray's point
 * @param n0 The first ray's direction vector.
 * @param p1 The second ray's point.
 * @param n1 The second ray's direction vector.
 */
function intersectRayRay(p0, n0, p1, n1) {
    var dx = p1[0] - p0[0];
    var dy = p1[1] - p0[1];
    var det = n1[0] * n0[1] - n1[1] * n0[0];
    var u = (dy * n1[0] - dx * n1[1]) / det;
    var v = (dy * n0[0] - dx * n0[1]) / det;
    if (u < 0 || v < 0)
        return createIntersection("miss");
    var m0 = n0[1] / n0[0];
    var m1 = n1[1] / n1[0];
    var b0 = p0[1] - m0 * p0[0];
    var b1 = p1[1] - m1 * p1[0];
    var x = (b1 - b0) / (m0 - m1);
    var y = m0 * x + b0;
    return Number.isFinite(x)
        ? createIntersection("intersection", [x, y])
        : createIntersection("parallel");
}
exports.intersectRayRay = intersectRayRay;
/**
 * Find the intersections between a ray and a line segment.
 * @param origin
 * @param direction
 * @param a1
 * @param a2
 */
function intersectRayLineSegment(origin, direction, a1, a2) {
    var x = origin[0], y = origin[1];
    var dx = direction[0], dy = direction[1];
    var x1 = a1[0], y1 = a1[1];
    var x2 = a2[0], y2 = a2[1];
    if (dy / dx !== (y2 - y1) / (x2 - x1)) {
        var d = dx * (y2 - y1) - dy * (x2 - x1);
        if (d !== 0) {
            var r = ((y - y1) * (x2 - x1) - (x - x1) * (y2 - y1)) / d;
            var s = ((y - y1) * dx - (x - x1) * dy) / d;
            if (r >= 0 && s >= 0 && s <= 1) {
                return createIntersection("intersection", [x + r * dx, y + r * dy]);
            }
        }
    }
    return createIntersection("no intersection");
}
exports.intersectRayLineSegment = intersectRayLineSegment;
/**
 * Find the intersections between a ray and a rectangle.
 * @param origin
 * @param direction
 * @param point
 * @param size
 * @param rotation
 */
function intersectRayRectangle(origin, direction, point, size, rotation) {
    if (rotation === void 0) { rotation = 0; }
    return intersectRectangleRay(point, size, rotation, origin, direction);
}
exports.intersectRayRectangle = intersectRayRectangle;
/**
 * Find the intersections between a ray and an ellipse.
 * @param origin
 * @param direction
 * @param center
 * @param rx
 * @param ry
 * @param rotation
 */
function intersectRayEllipse(origin, direction, center, rx, ry, rotation) {
    var a1 = origin;
    var a2 = vec_1.Vec.mul(direction, 999999999);
    return intersectLineSegmentEllipse(a1, a2, center, rx, ry, rotation);
}
exports.intersectRayEllipse = intersectRayEllipse;
/**
 * Find the intersections between a ray and a bounding box.
 * @param origin
 * @param direction
 * @param bounds
 * @param rotation
 */
function intersectRayBounds(origin, direction, bounds, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectRayRectangle(origin, direction, [minX, minY], [width, height], rotation);
}
exports.intersectRayBounds = intersectRayBounds;
/* -------------------------------------------------- */
/*                    Line Segment                    */
/* -------------------------------------------------- */
/**
 * Find the intersection between a line segment and a ray.
 * @param a1
 * @param a2
 * @param origin
 * @param direction
 */
function intersectLineSegmentRay(a1, a2, origin, direction) {
    return intersectRayLineSegment(origin, direction, a1, a2);
}
exports.intersectLineSegmentRay = intersectLineSegmentRay;
/**
 * Find the intersection between a line segment and a line segment.
 * @param a1
 * @param a2
 * @param b1
 * @param b2
 */
function intersectLineSegmentLineSegment(a1, a2, b1, b2) {
    var AB = vec_1.Vec.sub(a1, b1);
    var BV = vec_1.Vec.sub(b2, b1);
    var AV = vec_1.Vec.sub(a2, a1);
    var ua_t = BV[0] * AB[1] - BV[1] * AB[0];
    var ub_t = AV[0] * AB[1] - AV[1] * AB[0];
    var u_b = BV[1] * AV[0] - BV[0] * AV[1];
    if (ua_t === 0 || ub_t === 0) {
        return createIntersection("coincident");
    }
    if (u_b === 0) {
        return createIntersection("parallel");
    }
    if (u_b !== 0) {
        var ua = ua_t / u_b;
        var ub = ub_t / u_b;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
            return createIntersection("intersection", vec_1.Vec.add(a1, vec_1.Vec.mul(AV, ua)));
        }
    }
    return createIntersection("no intersection");
}
exports.intersectLineSegmentLineSegment = intersectLineSegmentLineSegment;
/**
 * Find the intersections between a line segment and a rectangle.
 * @param a1
 * @param a2
 * @param point
 * @param size
 */
function intersectLineSegmentRectangle(a1, a2, point, size) {
    return intersectRectangleLineSegment(point, size, a1, a2);
}
exports.intersectLineSegmentRectangle = intersectLineSegmentRectangle;
/**
 * Find the intersections between a line segment and an arc.
 * @param a1
 * @param a2
 * @param center
 * @param radius
 * @param start
 * @param end
 */
function intersectLineSegmentArc(a1, a2, center, radius, start, end) {
    var sa = vec_1.Vec.angle(center, start);
    var ea = vec_1.Vec.angle(center, end);
    var ellipseTest = intersectEllipseLineSegment(center, radius, radius, 0, a1, a2);
    if (!ellipseTest.didIntersect)
        return createIntersection("no intersection");
    var points = ellipseTest.points.filter(function (point) {
        return isAngleBetween(sa, ea, vec_1.Vec.angle(center, point));
    });
    if (points.length === 0) {
        return createIntersection("no intersection");
    }
    return createIntersection.apply(void 0, __spreadArray(["intersection"], points));
}
exports.intersectLineSegmentArc = intersectLineSegmentArc;
/**
 * Find the intersections between a line segment and a circle.
 * @param a1
 * @param a2
 * @param c
 * @param r
 */
function intersectLineSegmentCircle(a1, a2, c, r) {
    var a = (a2[0] - a1[0]) * (a2[0] - a1[0]) + (a2[1] - a1[1]) * (a2[1] - a1[1]);
    var b = 2 * ((a2[0] - a1[0]) * (a1[0] - c[0]) + (a2[1] - a1[1]) * (a1[1] - c[1]));
    var cc = c[0] * c[0] +
        c[1] * c[1] +
        a1[0] * a1[0] +
        a1[1] * a1[1] -
        2 * (c[0] * a1[0] + c[1] * a1[1]) -
        r * r;
    var deter = b * b - 4 * a * cc;
    if (deter < 0) {
        return createIntersection("outside");
    }
    if (deter === 0) {
        return createIntersection("tangent");
    }
    var e = Math.sqrt(deter);
    var u1 = (-b + e) / (2 * a);
    var u2 = (-b - e) / (2 * a);
    if ((u1 < 0 || u1 > 1) && (u2 < 0 || u2 > 1)) {
        if ((u1 < 0 && u2 < 0) || (u1 > 1 && u2 > 1)) {
            return createIntersection("outside");
        }
        else {
            return createIntersection("inside");
        }
    }
    var results = [];
    if (0 <= u1 && u1 <= 1)
        results.push(vec_1.Vec.lrp(a1, a2, u1));
    if (0 <= u2 && u2 <= 1)
        results.push(vec_1.Vec.lrp(a1, a2, u2));
    return createIntersection.apply(void 0, __spreadArray(["intersection"], results));
}
exports.intersectLineSegmentCircle = intersectLineSegmentCircle;
/**
 * Find the intersections between a line segment and an ellipse.
 * @param a1
 * @param a2
 * @param center
 * @param rx
 * @param ry
 * @param rotation
 */
function intersectLineSegmentEllipse(a1, a2, center, rx, ry, rotation) {
    if (rotation === void 0) { rotation = 0; }
    // If the ellipse or line segment are empty, return no tValues.
    if (rx === 0 || ry === 0 || vec_1.Vec.isEqual(a1, a2)) {
        return createIntersection("no intersection");
    }
    // Get the semimajor and semiminor axes.
    rx = rx < 0 ? rx : -rx;
    ry = ry < 0 ? ry : -ry;
    // Rotate points and translate so the ellipse is centered at the origin.
    a1 = vec_1.Vec.sub(vec_1.Vec.rotWith(a1, center, -rotation), center);
    a2 = vec_1.Vec.sub(vec_1.Vec.rotWith(a2, center, -rotation), center);
    // Calculate the quadratic parameters.
    var diff = vec_1.Vec.sub(a2, a1);
    var A = (diff[0] * diff[0]) / rx / rx + (diff[1] * diff[1]) / ry / ry;
    var B = (2 * a1[0] * diff[0]) / rx / rx + (2 * a1[1] * diff[1]) / ry / ry;
    var C = (a1[0] * a1[0]) / rx / rx + (a1[1] * a1[1]) / ry / ry - 1;
    // Make a list of t values (normalized points on the line where intersections occur).
    var tValues = [];
    // Calculate the discriminant.
    var discriminant = B * B - 4 * A * C;
    if (discriminant === 0) {
        // One real solution.
        tValues.push(-B / 2 / A);
    }
    else if (discriminant > 0) {
        var root = Math.sqrt(discriminant);
        // Two real solutions.
        tValues.push((-B + root) / 2 / A);
        tValues.push((-B - root) / 2 / A);
    }
    // Filter to only points that are on the segment.
    // Solve for points, then counter-rotate points.
    var points = tValues
        .filter(function (t) { return t >= 0 && t <= 1; })
        .map(function (t) { return vec_1.Vec.add(center, vec_1.Vec.add(a1, vec_1.Vec.mul(vec_1.Vec.sub(a2, a1), t))); })
        .map(function (p) { return vec_1.Vec.rotWith(p, center, rotation); });
    return createIntersection.apply(void 0, __spreadArray(["intersection"], points));
}
exports.intersectLineSegmentEllipse = intersectLineSegmentEllipse;
/**
 * Find the intersections between a line segment and a bounding box.
 * @param a1
 * @param a2
 * @param bounds
 */
function intersectLineSegmentBounds(a1, a2, bounds) {
    return intersectBoundsLineSegment(bounds, a1, a2);
}
exports.intersectLineSegmentBounds = intersectLineSegmentBounds;
/**
 * Find the intersections between a line segment and a polyline.
 * @param a1
 * @param a2
 * @param points
 */
function intersectLineSegmentPolyline(a1, a2, points) {
    var pts = [];
    for (var i = 1; i < points.length; i++) {
        var int = intersectLineSegmentLineSegment(a1, a2, points[i - 1], points[i]);
        if (int) {
            pts.push.apply(pts, int.points);
        }
    }
    if (pts.length === 0) {
        return createIntersection("no intersection");
    }
    return createIntersection.apply(void 0, __spreadArray(["intersection"], points));
}
exports.intersectLineSegmentPolyline = intersectLineSegmentPolyline;
/**
 * Find the intersections between a line segment and a closed polygon.
 * @param a1
 * @param a2
 * @param points
 */
function intersectLineSegmentPolygon(a1, a2, points) {
    var pts = [];
    for (var i = 1; i < points.length + 1; i++) {
        var int = intersectLineSegmentLineSegment(a1, a2, points[i - 1], points[i % points.length]);
        if (int) {
            pts.push.apply(pts, int.points);
        }
    }
    if (pts.length === 0) {
        return createIntersection("no intersection");
    }
    return createIntersection.apply(void 0, __spreadArray(["intersection"], points));
}
exports.intersectLineSegmentPolygon = intersectLineSegmentPolygon;
/* -------------------------------------------------- */
/*                      Rectangle                     */
/* -------------------------------------------------- */
/**
 * Find the intersections between a rectangle and a ray.
 * @param point
 * @param size
 * @param rotation
 * @param origin
 * @param direction
 */
function intersectRectangleRay(point, size, rotation, origin, direction) {
    var sideIntersections = getRectangleSides(point, size, rotation).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectRayLineSegment(origin, direction, a1, a2);
        if (intersection) {
            acc.push(createIntersection.apply(void 0, __spreadArray([message], intersection.points)));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleRay = intersectRectangleRay;
/**
 * Find the intersections between a rectangle and a line segment.
 * @param point
 * @param size
 * @param a1
 * @param a2
 */
function intersectRectangleLineSegment(point, size, a1, a2) {
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], b1 = _b[0], b2 = _b[1];
        var intersection = intersectLineSegmentLineSegment(a1, a2, b1, b2);
        if (intersection) {
            acc.push(createIntersection.apply(void 0, __spreadArray([message], intersection.points)));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleLineSegment = intersectRectangleLineSegment;
/**
 * Find the intersections between a rectangle and a rectangle.
 * @param point1
 * @param size1
 * @param point2
 * @param size2
 */
function intersectRectangleRectangle(point1, size1, point2, size2) {
    var sideIntersections = getRectangleSides(point1, size1).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersections = intersectRectangleLineSegment(point2, size2, a1, a2);
        acc.push.apply(acc, intersections.map(function (int) {
            return createIntersection.apply(void 0, __spreadArray([message + " " + int.message], int.points));
        }));
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleRectangle = intersectRectangleRectangle;
/**
 * Find the intersections between a rectangle and an arc.
 * @param point
 * @param size
 * @param center
 * @param radius
 * @param start
 * @param end
 */
function intersectRectangleArc(point, size, center, radius, start, end) {
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectArcLineSegment(center, radius, start, end, a1, a2);
        if (intersection) {
            acc.push(__assign(__assign({}, intersection), { message: message }));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleArc = intersectRectangleArc;
/**
 * Find the intersections between a rectangle and a circle.
 * @param point
 * @param size
 * @param c
 * @param r
 */
function intersectRectangleCircle(point, size, c, r) {
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectLineSegmentCircle(a1, a2, c, r);
        if (intersection) {
            acc.push(__assign(__assign({}, intersection), { message: message }));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleCircle = intersectRectangleCircle;
/**
 * Find the intersections between a rectangle and an ellipse.
 * @param point
 * @param size
 * @param c
 * @param rx
 * @param ry
 * @param rotation
 */
function intersectRectangleEllipse(point, size, c, rx, ry, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectLineSegmentEllipse(a1, a2, c, rx, ry, rotation);
        if (intersection) {
            acc.push(__assign(__assign({}, intersection), { message: message }));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectangleEllipse = intersectRectangleEllipse;
/**
 * Find the intersections between a rectangle and a bounding box.
 * @param point
 * @param size
 * @param bounds
 */
function intersectRectangleBounds(point, size, bounds) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectRectangleRectangle(point, size, [minX, minY], [width, height]);
}
exports.intersectRectangleBounds = intersectRectangleBounds;
/**
 * Find the intersections between a rectangle and a polyline.
 * @param point
 * @param size
 * @param points
 */
function intersectRectanglePolyline(point, size, points) {
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectLineSegmentPolyline(a1, a2, points);
        if (intersection.didIntersect) {
            acc.push(createIntersection.apply(void 0, __spreadArray([message], intersection.points)));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectanglePolyline = intersectRectanglePolyline;
/**
 * Find the intersections between a rectangle and a polygon.
 * @param point
 * @param size
 * @param points
 */
function intersectRectanglePolygon(point, size, points) {
    var sideIntersections = getRectangleSides(point, size).reduce(function (acc, _a) {
        var message = _a[0], _b = _a[1], a1 = _b[0], a2 = _b[1];
        var intersection = intersectLineSegmentPolygon(a1, a2, points);
        if (intersection.didIntersect) {
            acc.push(createIntersection.apply(void 0, __spreadArray([message], intersection.points)));
        }
        return acc;
    }, []);
    return sideIntersections.filter(function (int) { return int.didIntersect; });
}
exports.intersectRectanglePolygon = intersectRectanglePolygon;
/* -------------------------------------------------- */
/*                         Arc                        */
/* -------------------------------------------------- */
/**
 * Find the intersections between a arc and a line segment.
 * @param center
 * @param radius
 * @param start
 * @param end
 * @param a1
 * @param a2
 */
function intersectArcLineSegment(center, radius, start, end, a1, a2) {
    return intersectLineSegmentArc(a1, a2, center, radius, start, end);
}
exports.intersectArcLineSegment = intersectArcLineSegment;
/**
 * Find the intersections between a arc and a rectangle.
 * @param center
 * @param radius
 * @param start
 * @param end
 * @param point
 * @param size
 */
function intersectArcRectangle(center, radius, start, end, point, size) {
    return intersectRectangleArc(point, size, center, radius, start, end);
}
exports.intersectArcRectangle = intersectArcRectangle;
/**
 * Find the intersections between a arc and a bounding box.
 * @param center
 * @param radius
 * @param start
 * @param end
 * @param bounds
 */
function intersectArcBounds(center, radius, start, end, bounds) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectArcRectangle(center, radius, start, end, [minX, minY], [width, height]);
}
exports.intersectArcBounds = intersectArcBounds;
/* -------------------------------------------------- */
/*                       Circle                       */
/* -------------------------------------------------- */
/**
 * Find the intersections between a circle and a line segment.
 * @param c
 * @param r
 * @param a1
 * @param a2
 */
function intersectCircleLineSegment(c, r, a1, a2) {
    return intersectLineSegmentCircle(a1, a2, c, r);
}
exports.intersectCircleLineSegment = intersectCircleLineSegment;
/**
 * Find the intersections between a circle and a circle.
 * @param c1
 * @param r1
 * @param c2
 * @param r2
 */
function intersectCircleCircle(c1, r1, c2, r2) {
    var dx = c2[0] - c1[0], dy = c2[1] - c1[1];
    var d = Math.sqrt(dx * dx + dy * dy), x = (d * d - r2 * r2 + r1 * r1) / (2 * d), y = Math.sqrt(r1 * r1 - x * x);
    dx /= d;
    dy /= d;
    return createIntersection("intersection", [c1[0] + dx * x - dy * y, c1[1] + dy * x + dx * y], [c1[0] + dx * x + dy * y, c1[1] + dy * x - dx * y]);
}
exports.intersectCircleCircle = intersectCircleCircle;
/**
 * Find the intersections between a circle and a rectangle.
 * @param c
 * @param r
 * @param point
 * @param size
 */
function intersectCircleRectangle(c, r, point, size) {
    return intersectRectangleCircle(point, size, c, r);
}
exports.intersectCircleRectangle = intersectCircleRectangle;
/**
 * Find the intersections between a circle and a bounding box.
 * @param c
 * @param r
 * @param bounds
 */
function intersectCircleBounds(c, r, bounds) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectCircleRectangle(c, r, [minX, minY], [width, height]);
}
exports.intersectCircleBounds = intersectCircleBounds;
/* -------------------------------------------------- */
/*                       Ellipse                      */
/* -------------------------------------------------- */
/**
 * Find the intersections between an ellipse and a ray.
 * @param center
 * @param rx
 * @param ry
 * @param rotation
 * @param point
 * @param direction
 */
function intersectEllipseRay(center, rx, ry, rotation, point, direction) {
    return intersectRayEllipse(point, direction, center, rx, ry, rotation);
}
exports.intersectEllipseRay = intersectEllipseRay;
/**
 * Find the intersections between an ellipse and a line segment.
 * @param center
 * @param rx
 * @param ry
 * @param rotation
 * @param a1
 * @param a2
 */
function intersectEllipseLineSegment(center, rx, ry, rotation, a1, a2) {
    if (rotation === void 0) { rotation = 0; }
    if (rx === ry) {
        return intersectLineSegmentCircle(a1, a2, center, rx);
    }
    return intersectLineSegmentEllipse(a1, a2, center, rx, ry, rotation);
}
exports.intersectEllipseLineSegment = intersectEllipseLineSegment;
/**
 * Find the intersections between an ellipse and a rectangle.
 * @param center
 * @param rx
 * @param ry
 * @param rotation
 * @param point
 * @param size
 */
function intersectEllipseRectangle(center, rx, ry, rotation, point, size) {
    if (rotation === void 0) { rotation = 0; }
    if (rx === ry) {
        return intersectRectangleCircle(point, size, center, rx);
    }
    return intersectRectangleEllipse(point, size, center, rx, ry, rotation);
}
exports.intersectEllipseRectangle = intersectEllipseRectangle;
/**
 * Find the intersections between an ellipse and an ellipse.
 * Adapted from https://gist.github.com/drawable/92792f59b6ff8869d8b1
 * @param _c1
 * @param _rx1
 * @param _ry1
 * @param _r1
 * @param _c2
 * @param _rx2
 * @param _ry2
 * @param _r2
 */
function intersectEllipseEllipse(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_c1, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_rx1, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ry1, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_r1, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_c2, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_rx2, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ry2, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_r2) {
    // TODO
    return createIntersection("no intersection");
}
exports.intersectEllipseEllipse = intersectEllipseEllipse;
/**
 * Find the intersections between an ellipse and a circle.
 * @param c
 * @param rx
 * @param ry
 * @param rotation
 * @param c2
 * @param r2
 */
function intersectEllipseCircle(c, rx, ry, rotation, c2, r2) {
    return intersectEllipseEllipse(c, rx, ry, rotation, c2, r2, r2, 0);
}
exports.intersectEllipseCircle = intersectEllipseCircle;
/**
 * Find the intersections between an ellipse and a bounding box.
 * @param c
 * @param rx
 * @param ry
 * @param rotation
 * @param bounds
 */
function intersectEllipseBounds(c, rx, ry, rotation, bounds) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectEllipseRectangle(c, rx, ry, rotation, [minX, minY], [width, height]);
}
exports.intersectEllipseBounds = intersectEllipseBounds;
/**
 * Find the intersections between a bounding box and a ray.
 * @param bounds
 * @param origin
 * @param direction
 */
function intersectBoundsRay(bounds, origin, direction) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectRayRectangle(origin, direction, [minX, minY], [width, height]);
}
exports.intersectBoundsRay = intersectBoundsRay;
/**
 * Find the intersections between a bounding box and a line segment.
 * @param bounds
 * @param a1
 * @param a2
 */
function intersectBoundsLineSegment(bounds, a1, a2) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectLineSegmentRectangle(a1, a2, [minX, minY], [width, height]);
}
exports.intersectBoundsLineSegment = intersectBoundsLineSegment;
/**
 * Find the intersections between a bounding box and a rectangle.
 * @param bounds
 * @param point
 * @param size
 */
function intersectBoundsRectangle(bounds, point, size) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectRectangleRectangle(point, size, [minX, minY], [width, height]);
}
exports.intersectBoundsRectangle = intersectBoundsRectangle;
/**
 * Find the intersections between a bounding box and a bounding box.
 * @param bounds1
 * @param bounds2
 */
function intersectBoundsBounds(bounds1, bounds2) {
    return intersectRectangleRectangle([bounds1.minX, bounds1.minY], [bounds1.width, bounds1.height], [bounds2.minX, bounds2.minY], [bounds2.width, bounds2.height]);
}
exports.intersectBoundsBounds = intersectBoundsBounds;
/**
 * Find the intersections between a bounding box and an arc.
 * @param bounds
 * @param center
 * @param radius
 * @param start
 * @param end
 */
function intersectBoundsArc(bounds, center, radius, start, end) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectArcRectangle(center, radius, start, end, [minX, minY], [width, height]);
}
exports.intersectBoundsArc = intersectBoundsArc;
/**
 * Find the intersections between a bounding box and a circle.
 * @param bounds
 * @param c
 * @param r
 */
function intersectBoundsCircle(bounds, c, r) {
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectCircleRectangle(c, r, [minX, minY], [width, height]);
}
exports.intersectBoundsCircle = intersectBoundsCircle;
/**
 * Find the intersections between a bounding box and an ellipse.
 * @param bounds
 * @param c
 * @param rx
 * @param ry
 * @param rotation
 */
function intersectBoundsEllipse(bounds, c, rx, ry, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var minX = bounds.minX, minY = bounds.minY, width = bounds.width, height = bounds.height;
    return intersectEllipseRectangle(c, rx, ry, rotation, [minX, minY], [width, height]);
}
exports.intersectBoundsEllipse = intersectBoundsEllipse;
/**
 * Find the intersections between a bounding box and a polyline.
 * @param bounds
 * @param points
 */
function intersectBoundsPolyline(bounds, points) {
    return intersectPolylineBounds(points, bounds);
}
exports.intersectBoundsPolyline = intersectBoundsPolyline;
/**
 * Find the intersections between a bounding box and a polygon.
 * @param bounds
 * @param points
 */
function intersectBoundsPolygon(bounds, points) {
    return intersectPolygonBounds(points, bounds);
}
exports.intersectBoundsPolygon = intersectBoundsPolygon;
/* -------------------------------------------------- */
/*                      Polyline                      */
/* -------------------------------------------------- */
/**
 * Find the intersections between a polyline and a line segment.
 * @param points
 * @param a1
 * @param a2
 */
function intersectPolylineLineSegment(points, a1, a2) {
    return intersectLineSegmentPolyline(a1, a2, points);
}
exports.intersectPolylineLineSegment = intersectPolylineLineSegment;
/**
 * Find the intersections between a polyline and a rectangle.
 * @param points
 * @param point
 * @param size
 */
function intersectPolylineRectangle(points, point, size) {
    return intersectRectanglePolyline(point, size, points);
}
exports.intersectPolylineRectangle = intersectPolylineRectangle;
/**
 * Find the intersections between a polyline and a bounding box.
 * @param points
 * @param bounds
 */
function intersectPolylineBounds(points, bounds) {
    return intersectRectanglePolyline([bounds.minX, bounds.minY], [bounds.width, bounds.height], points);
}
exports.intersectPolylineBounds = intersectPolylineBounds;
/* -------------------------------------------------- */
/*                       Polygon                      */
/* -------------------------------------------------- */
/**
 * Find the intersections between a polygon nd a line segment.
 * @param points
 * @param a1
 * @param a2
 */
function intersectPolygonLineSegment(points, a1, a2) {
    return intersectLineSegmentPolyline(a1, a2, points);
}
exports.intersectPolygonLineSegment = intersectPolygonLineSegment;
/**
 * Find the intersections between a polygon and a rectangle.
 * @param points
 * @param point
 * @param size
 */
function intersectPolygonRectangle(points, point, size) {
    return intersectRectanglePolyline(point, size, points);
}
exports.intersectPolygonRectangle = intersectPolygonRectangle;
/**
 * Find the intersections between a polygon and a bounding box.
 * @param points
 * @param bounds
 */
function intersectPolygonBounds(points, bounds) {
    return intersectRectanglePolygon([bounds.minX, bounds.minY], [bounds.width, bounds.height], points);
}
exports.intersectPolygonBounds = intersectPolygonBounds;



// WEBPACK FOOTER //
// ./src/modules/whiteboard/@tldraw/intersect/index.js